/**
 * Página dedicada de Follow-up.
 * Renderiza o gestor de campanhas fora das Configurações para ser
 * acessível diretamente pela sidebar.
 * Margens do design system (seção 5.2): 16 px no celular, 24 px no tablet e 32 px no desktop.
 */
import { FollowupManagement } from '@/components/followup/FollowupManagement';

export default function FollowupPage() {
  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:p-6 md:p-8">
      <FollowupManagement />
    </div>
  );
}
